import React from 'react';
import { FaTrophy } from 'react-icons/fa';

const ProgressAccuracy = ({ accuracy, small }) => (
   <p className="progress-accuracy">
      {!small && <span>Accuracy</span>}
      {!small && accuracy === 100 && <FaTrophy />}
      {accuracy}%
   </p>
);

export { ProgressAccuracy };
